{
  "metadata": {
    "id": "mercury-light",
    "name": "Mercury",
    "description": "Портировано из темы «Mercury» (light)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "light",
    "tags": [
      "light",
      "ported"
    ],
    "source": {
      "file": "mercury.json",
      "project": "opencode",
      "url": "https://github.com/anomalyco/opencode",
      "upstreamFile": "packages/ui/src/theme/themes/mercury.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 25.5,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.446,
      "paletteMaxS": 0.51,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 8.0,
      "surfacesTarget": 8.0,
      "surfacesRaisedTarget": 10.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 22.6,
      "syntaxVsTextMinDeltaE": 14.9,
      "chartsMinDeltaE": 41.2,
      "textSeparationDeltaE": 10.2,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "keyword",
          "b": "function",
          "deltaE": 9.0
        },
        {
          "a": "keyword",
          "b": "operator",
          "deltaE": 0.0
        },
        {
          "a": "function",
          "b": "operator",
          "deltaE": 9.0
        }
      ],
      "modeLabel": "light",
      "modeFromLuminance": "light",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#5266eb",
      "hover": "#4a5cd4",
      "active": "#4354c1",
      "foreground": "#ffffff",
      "muted": "#5266eb80",
      "emphasis": "#5266eb"
    },
    "surface": {
      "background": "#ffffff",
      "foreground": "#343442",
      "muted": "#d1d1d5",
      "mutedForeground": "#4a4a53",
      "elevated": "#babac0",
      "elevatedForeground": "#363644",
      "raised": "#9f9fa7",
      "raisedForeground": "#363644",
      "overlay": "#ffffff33",
      "subtle": "#e8e8ea"
    },
    "interactive": {
      "border": "#97979f",
      "borderHover": "#c7c7cb",
      "borderFocus": "#5266eb",
      "selection": "#36364424",
      "selectionForeground": "#363644",
      "focus": "#5266eb59",
      "focusRing": "#5266eb47",
      "cursor": "#363644",
      "hover": "#36364417",
      "active": "#36364424"
    },
    "status": {
      "error": "#b0175f",
      "errorForeground": "#ffffff",
      "errorBackground": "#b0175f1a",
      "errorBorder": "#b0175f59",
      "warning": "#a44200",
      "warningForeground": "#ffffff",
      "warningBackground": "#a442001a",
      "warningBorder": "#a4420059",
      "success": "#036e43",
      "successForeground": "#ffffff",
      "successBackground": "#036e431a",
      "successBorder": "#036e4359",
      "info": "#007f95",
      "infoForeground": "#ffffff",
      "infoBackground": "#007f951a",
      "infoBorder": "#007f9559"
    },
    "pr": {
      "open": "#036e43",
      "draft": "#585862",
      "blocked": "#a44200",
      "merged": "#718ef3",
      "closed": "#b0175f"
    },
    "syntax": {
      "base": {
        "background": "#d1d1d5",
        "foreground": "#363644",
        "comment": "#585862",
        "keyword": "#324acb",
        "string": "#03643d",
        "number": "#9a3e00",
        "function": "#2942e6",
        "variable": "#006171",
        "type": "#006171",
        "operator": "#324acb"
      },
      "tokens": {
        "commentDoc": "#585862",
        "stringEscape": "#324acb",
        "keywordImport": "#324acb",
        "storageModifier": "#324acb",
        "functionCall": "#2942e6",
        "method": "#2942e6",
        "variableProperty": "#2942e6",
        "variableOther": "#006171",
        "variableGlobal": "#9a3e00",
        "variableLocal": "#324acb",
        "parameter": "#006171",
        "constant": "#9a3e00",
        "class": "#006171",
        "className": "#006171",
        "interface": "#006171",
        "struct": "#006171",
        "enum": "#006171",
        "typeParameter": "#006171",
        "namespace": "#006171",
        "module": "#324acb",
        "tag": "#324acb",
        "jsxTag": "#324acb",
        "tagAttribute": "#2942e6",
        "tagAttributeValue": "#03643d",
        "boolean": "#9a3e00",
        "decorator": "#324acb",
        "label": "#2942e6",
        "regexp": "#03643d"
      }
    },
    "charts": {
      "series": [
        "#5266eb",
        "#007f95",
        "#036e43",
        "#a44200",
        "#b0175f"
      ]
    },
    "chat": {
      "background": "#ffffff",
      "userMessage": "#363644",
      "userMessageBackground": "#babac0",
      "assistantMessage": "#363644",
      "assistantMessageBackground": "#d1d1d5",
      "timestamp": "#585862",
      "divider": "#97979f",
      "typing": "#585862"
    },
    "loading": {
      "spinner": "#5266eb",
      "spinnerTrack": "#d1d1d5",
      "skeleton": "#d1d1d5",
      "shimmer": "#c8c8cc"
    },
    "tools": {
      "background": "#d1d1d5",
      "border": "#97979f",
      "headerHover": "#c9c9ce",
      "icon": "#5266eb",
      "title": "#363644",
      "description": "#585862",
      "edit": {
        "added": "#036e43",
        "addedBackground": "#036e431a",
        "removed": "#b0175f",
        "removedBackground": "#b0175f1a",
        "modified": "#007f95",
        "modifiedBackground": "#007f951a",
        "lineNumber": "#585862"
      }
    },
    "markdown": {
      "heading1": "#363644",
      "heading2": "#363644",
      "heading3": "#363644",
      "heading4": "#363644",
      "link": "#5266eb",
      "linkHover": "#4a5cd4",
      "inlineCode": "#03643d",
      "inlineCodeBackground": "#d1d1d5",
      "blockquote": "#585862",
      "blockquoteBorder": "#97979f",
      "listMarker": "#5266ebbf",
      "bold": "#363644",
      "italic": "#363644e6",
      "strikethrough": "#585862",
      "hr": "#97979f"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#ac423a",
        "foreground": "#ffffff",
        "contrast": 5.84
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#a56c46",
        "foreground": "#000000",
        "contrast": 4.83
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#d8b889",
        "foreground": "#000000",
        "contrast": 11.14
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#b4ae4c",
        "foreground": "#000000",
        "contrast": 9.1
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#b0d491",
        "foreground": "#000000",
        "contrast": 12.67
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#7acc62",
        "foreground": "#000000",
        "contrast": 10.64
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#4fa972",
        "foreground": "#000000",
        "contrast": 7.25
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#91d3c3",
        "foreground": "#000000",
        "contrast": 12.31
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#4d99a7",
        "foreground": "#000000",
        "contrast": 6.43
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#4575a3",
        "foreground": "#ffffff",
        "contrast": 4.85
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#3759a9",
        "foreground": "#ffffff",
        "contrast": 6.64
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#4439a7",
        "foreground": "#ffffff",
        "contrast": 8.79
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#a583d3",
        "foreground": "#000000",
        "contrast": 6.79
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#a841ac",
        "foreground": "#ffffff",
        "contrast": 5.23
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#cf8bb4",
        "foreground": "#000000",
        "contrast": 8.01
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#ad3e6a",
        "foreground": "#ffffff",
        "contrast": 5.72
      }
    ]
  }
}
